import { CheckBoxWrapper, Label, CheckBox } from './styles';
import { BoxIcon } from '#atoms';

interface CheckBoxAtomProps {
  id: string;
  label?: string;
  checked?: boolean;
  onClick?: () => void;
  labelStyle?: React.CSSProperties;
}

export default function CheckBoxAtom({
  id,
  label,
  checked = false,
  onClick,
  labelStyle,
  ...props
}: CheckBoxAtomProps) {
  return (
    <CheckBoxWrapper>
      <CheckBox
        id={id}
        className={checked ? 'checked' : ''}
        onClick={onClick}
        {...props}
      >
        {checked ? <CheckIcon /> : <UnCheckedCheckIcon />}
      </CheckBox>
      {label && (
        <Label onClick={onClick} style={labelStyle}>
          {label}
        </Label>
      )}
      {/* {label && <Label style={labelStyle}>{label}</Label>} */}
    </CheckBoxWrapper>
  );
}

const UnCheckedCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
      fill="#5C576B"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
      fill="white"
    />
  </svg>
);
